"use client";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import {
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Switch,
  Tooltip,
  Typography,
} from "antd";
import dayjs from "dayjs";
import { BOM } from "../../../../../services/definedMethod";

const { Text } = Typography;

const ChannelsAndAccessForm = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    assetAccountOptions,
    incomeAccountOptions,
    checkedMobileApp,
    checkedUSSD,
    checkedWebPortal,
    checkedATM,
    checkedPOS,
    checkedAPI,
    selectedCurrencySymbol,
    checkedQRCode,
    setCheckedMobileApp,
    setCheckedUSSD,
    setCheckedWebPortal,
    setCheckedATM,
    setCheckedPOS,
    setCheckedAPI,
    setCheckedQRCode,
    multiFactorAuthenticationOptions,
  } = props;

  const handleMobileAppChange = (checked) => {
    setCheckedMobileApp(checked);
  };

  const handleUSSDChange = (checked) => {
    setCheckedUSSD(checked);
  };

  const handleWebPortalChange = (checked) => {
    setCheckedWebPortal(checked);
  };

  const handleATMChange = (checked) => {
    setCheckedATM(checked);
  };

  const handlePOSChange = (checked) => {
    setCheckedPOS(checked);
  };

  const handleAPIChange = (checked) => {
    setCheckedAPI(checked);
  };

  const handleQRCodeChange = (checked) => {
    setCheckedQRCode(checked);
  };

  return (
    <div>
      <h1 style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
        Channels & Access
      </h1>
      <p
        style={{
          color: "#6b7280",
          fontWeight: "400",
          marginBottom: "24px",
          marginTop: 0,
        }}
      >
        Add description text to note for users when adding the accrual options
      </p>

      <Form
        className="custom-form"
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={initialValues}
        style={{ marginY: 30 }}
      >
        <Row
          style={{
            background: "#F9FAFB",
            padding: "12px 24px",
            borderRadius: "8px 8px 0 0",
            marginBottom: "8px",
          }}
        >
          <Col span={8}>
            <span style={{ color: "#344054", fontWeight: 500 }}>Channels</span>
          </Col>
          <Col span={8}>
            <span style={{ color: "#344054", fontWeight: 500 }}>
              Transaction Limits
            </span>
          </Col>
          <Col span={8}>
            <span style={{ color: "#344054", fontWeight: 500 }}>
              Multi-Factor Authentication
            </span>
          </Col>
        </Row>
        <Row justify="center" align="middle">
          <Col span={8} style={{ height: "68px", paddingLeft: "24px" }}>
            <Row
              style={{
                alignContent: "center",
                display: "flex",
                height: "100%",
              }}
            >
              {" "}
              <Switch
                onClick={props.onSwitchClick}
                checked={checkedMobileApp}
                onChange={handleMobileAppChange}
                style={{
                  backgroundColor: checkedMobileApp ? "#b026ff" : "#F2F4F7",
                }}
              />
              <div style={{ width: "60%" }}>
                <Text style={{ marginLeft: 10 }}>Mobile App</Text>
              </div>
            </Row>
          </Col>
          <Col span={8}>
            <Form.Item
              // name={["mobileAppLimit", 0]}
              name={"mobileAppLimit"}
              rules={[
                {
                  required: checkedMobileApp,
                  message: "Please select a GL account",
                },
              ]}
              style={{ margin: "0px 0px" }}
              hidden={checkedMobileApp ? false : true}
            >
              <InputNumber
                className="mobileAppLimit-input"
                placeholder="Enter Limit"
                prefix={selectedCurrencySymbol}
                style={{ width: "90%", height: "44px" }}
                formatter={BOM.FormatAmount}
                parser={BOM.ParseAmount}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name={"mobileAppMultiFactorAuthentication"}
              rules={[
                {
                  required: checkedMobileApp,
                  message: "Please select an authentication",
                },
              ]}
              style={{ margin: "0px 0px" }}
              hidden={checkedMobileApp ? false : true}
            >
              <Select
                placeholder="Select an authentication"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={multiFactorAuthenticationOptions}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center" align="middle">
          <Col span={8} style={{ height: "68px", paddingLeft: "24px" }}>
            <Row
              style={{
                alignContent: "center",
                display: "flex",
                height: "100%",
              }}
            >
              {" "}
              <Switch
                onClick={props.onSwitchClick}
                checked={checkedUSSD}
                onChange={handleUSSDChange}
                style={{
                  backgroundColor: checkedUSSD ? "#b026ff" : "#F2F4F7",
                }}
              />
              <div style={{ width: "60%" }}>
                <Text style={{ marginLeft: 10 }}>USSD</Text>
              </div>
            </Row>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              // name={["ussdLimit", 0]}
              name={"ussdLimit"}
              rules={[
                {
                  required: checkedUSSD,
                  message: "Please select a GL account",
                },
              ]}
              style={{ margin: "0px 0px" }}
              hidden={checkedUSSD ? false : true}
            >
              <InputNumber
                className="ussdLimit-input"
                placeholder="Enter Limit"
                prefix={selectedCurrencySymbol}
                style={{ width: "90%", height: "44px" }}
                formatter={BOM.FormatAmount}
                parser={BOM.ParseAmount}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={"ussdMultiFactorAuthentication"}
              rules={[
                {
                  required: checkedUSSD,
                  message: "Please select an authentication",
                },
              ]}
              style={{ margin: "0px 0px" }}
              hidden={checkedUSSD ? false : true}
            >
              <Select
                placeholder="Select an authentication"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={multiFactorAuthenticationOptions}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center" align="middle">
          <Col span={8} style={{ height: "68px", paddingLeft: "24px" }}>
            <Row
              style={{
                alignContent: "center",
                display: "flex",
                height: "100%",
              }}
            >
              {" "}
              <Switch
                onClick={props.onSwitchClick}
                checked={checkedWebPortal}
                onChange={handleWebPortalChange}
                style={{
                  backgroundColor: checkedWebPortal ? "#b026ff" : "#F2F4F7",
                }}
              />
              <div style={{ width: "60%" }}>
                <Text style={{ marginLeft: 10 }}>Web Portal</Text>
              </div>
            </Row>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={"webPortalLimit"}
              rules={[
                {
                  required: checkedWebPortal,
                  message: "Please select a GL account",
                },
              ]}
              style={{ margin: "0px 0px" }}
              hidden={checkedWebPortal ? false : true}
            >
              <InputNumber
                className="webPortalLimit-input"
                placeholder="Enter Limit"
                prefix={selectedCurrencySymbol}
                style={{ width: "90%", height: "44px" }}
                formatter={BOM.FormatAmount}
                parser={BOM.ParseAmount}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={"webPortalMultiFactorAuthentication"}
              rules={[
                {
                  required: checkedWebPortal,
                  message: "Please select an authentication",
                },
              ]}
              style={{ margin: "0px 0px" }}
              hidden={checkedWebPortal ? false : true}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={multiFactorAuthenticationOptions}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center" align="middle">
          <Col span={8} style={{ height: "68px", paddingLeft: "24px" }}>
            <Row
              style={{
                alignContent: "center",
                display: "flex",
                height: "100%",
              }}
            >
              {" "}
              <Switch
                onClick={props.onSwitchClick}
                checked={checkedATM}
                onChange={handleATMChange}
                style={{
                  backgroundColor: checkedATM ? "#b026ff" : "#F2F4F7",
                }}
              />
              <div style={{ width: "60%" }}>
                <Text style={{ marginLeft: 10 }}>ATM</Text>
              </div>
            </Row>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={"atm"}
              rules={[
                {
                  required: checkedATM,
                  message: "Please select a GL account",
                },
              ]}
              style={{ margin: "0px 0px" }}
              hidden={checkedATM ? false : true}
            >
              <InputNumber
                className="mobileAppLimit-input"
                placeholder="Enter Limit"
                prefix={selectedCurrencySymbol}
                style={{ width: "90%", height: "44px" }}
                formatter={BOM.FormatAmount}
                parser={BOM.ParseAmount}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={"atmMultiFactorAuthentication"}
              rules={[
                {
                  required: checkedATM,
                  message: "Please select an authentication",
                },
              ]}
              style={{ margin: "0px 0px" }}
              hidden={checkedATM ? false : true}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={multiFactorAuthenticationOptions}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center" align="middle">
          <Col span={8} style={{ height: "68px", paddingLeft: "24px" }}>
            <Row
              style={{
                alignContent: "center",
                display: "flex",
                height: "100%",
              }}
            >
              {" "}
              <Switch
                onClick={props.onSwitchClick}
                checked={checkedPOS}
                onChange={handlePOSChange}
                style={{
                  backgroundColor: checkedPOS ? "#b026ff" : "#F2F4F7",
                }}
              />
              <div style={{ width: "60%" }}>
                <Text style={{ marginLeft: 10 }}>POS</Text>
              </div>
            </Row>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={"posGL"}
              rules={[
                {
                  required: checkedPOS,
                  message: "Please select a GL account",
                },
              ]}
              style={{ margin: "0px 0px" }}
              hidden={checkedPOS ? false : true}
            >
              <InputNumber
                className="mobileAppLimit-input"
                placeholder="Enter Limit"
                prefix={selectedCurrencySymbol}
                style={{ width: "90%", height: "44px" }}
                formatter={BOM.FormatAmount}
                parser={BOM.ParseAmount}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={"posMultiFactorAuthentication"}
              rules={[
                {
                  required: checkedPOS,
                  message: "Please select an authentication",
                },
              ]}
              style={{ margin: "0px 0px" }}
              hidden={checkedPOS ? false : true}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={multiFactorAuthenticationOptions}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center" align="middle">
          <Col span={8} style={{ height: "68px", paddingLeft: "24px" }}>
            <Row
              style={{
                alignContent: "center",
                display: "flex",
                height: "100%",
              }}
            >
              {" "}
              <Switch
                onClick={props.onSwitchClick}
                checked={checkedAPI}
                onChange={handleAPIChange}
                style={{
                  backgroundColor: checkedAPI ? "#b026ff" : "#F2F4F7",
                }}
              />
              <div style={{ width: "60%" }}>
                <Text style={{ marginLeft: 10 }}>API</Text>
              </div>
            </Row>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={["apiGL"]}
              rules={[
                {
                  required: checkedAPI,
                  message: "Please select a GL account",
                },
              ]}
              style={{ margin: "0px 0px" }}
              hidden={checkedAPI ? false : true}
            >
              <InputNumber
                className="mobileAppLimit-input"
                placeholder="Enter Limit"
                prefix={selectedCurrencySymbol}
                style={{ width: "90%", height: "44px" }}
                formatter={BOM.FormatAmount}
                parser={BOM.ParseAmount}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={"apiMultiFactorAuthentication"}
              rules={[
                {
                  required: checkedAPI,
                  message: "Please select an authentication",
                },
              ]}
              style={{ margin: "0px 0px" }}
              hidden={checkedAPI ? false : true}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={multiFactorAuthenticationOptions}
              />
            </Form.Item>
          </Col>
        </Row>{" "}
        <Row justify="center" align="middle">
          <Col span={8} style={{ height: "68px", paddingLeft: "24px" }}>
            <Row
              style={{
                alignContent: "center",
                display: "flex",
                height: "100%",
              }}
            >
              {" "}
              <Switch
                onClick={props.onSwitchClick}
                checked={checkedQRCode}
                onChange={handleQRCodeChange}
                style={{
                  backgroundColor: checkedQRCode ? "#b026ff" : "#F2F4F7",
                }}
              />
              <div style={{ width: "60%" }}>
                <Text style={{ marginLeft: 10 }}>QR Code</Text>
              </div>
            </Row>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={"qrCodeGL"}
              rules={[
                {
                  required: checkedQRCode,
                  message: "Please select a GL account",
                },
              ]}
              style={{ margin: "0px 0px" }}
              hidden={checkedQRCode ? false : true}
            >
              <InputNumber
                className="mobileAppLimit-input"
                placeholder="Enter Limit"
                prefix={selectedCurrencySymbol}
                style={{ width: "90%", height: "44px" }}
                formatter={BOM.FormatAmount}
                parser={BOM.ParseAmount}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={"qrCodeMultiFactorAuthentication"}
              rules={[
                {
                  required: checkedQRCode,
                  message: "Please select an authentication",
                },
              ]}
              style={{ margin: "0px 0px" }}
              hidden={checkedQRCode ? false : true}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={multiFactorAuthenticationOptions}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ChannelsAndAccessForm;
